import MartCard from './MartCard';
import VipPassCard from './VipPassCard';
import RapCoinCard from './RapCoinCard';
import RapGemCard from './RapGemCard';
import VipRoomCard from './VipRoomCard';

export default function ProductCard({ card, onClick, userXp = 0 }) {
  if (card.variant === 'mart') {
    return <MartCard card={card} onClick={onClick} userXp={userXp} />;
  }

  if (card.variant === 'passes') {
    return <VipPassCard card={card} onClick={onClick} />;
  }

  if (card.variant === 'store' && card.tone === 'coin') {
    return <RapCoinCard card={card} onClick={onClick} />;
  }

  if (card.variant === 'store' && card.tone?.includes('gem')) {
    return <RapGemCard card={card} onClick={onClick} />;
  }

  if (card.variant === 'store' && card.tone === 'vip') {
    return <VipRoomCard card={card} onClick={onClick} />;
  }

  return null;
}
